import styled, { css, keyframes } from "styled-components";

export const ElevatoriaStyled = styled.main`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  display: flex;
  margin: auto 0;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  background: ${(props) => (props.darkmode ? "#292929" : null)};

  background: ${(props) => (props.darkmode ? ` var(--background-dark)` : null)};

  .IconAlerte {
    display: flex;
    align-items: center;
    position: absolute;
    top: 78px;
    right: 10%;
    @media (max-width: 600px) {
      right: 5%;
    }
    .darkmode {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px 15px;
      font-size: 18px;
      border-radius: 80px;
      background-color: ${(props) =>
        props.darkmode ? "#C9C9C9" : "var(--branco)"};
      border: 2px solid var(--cor-primaria);
      gap: 20px;
      position: relative;
      width: 90px;
      height: 50px;
      cursor: pointer;
      z-index: 5;
      span {
        position: absolute;
        background-color: var(--cor-primaria);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        left: ${(props) => (props.darkmode ? "41px" : "5px")};
        transition: 0.8s;
      }
      .icone01 {
        color: ${(props) => (props.darkmode ? "black" : "white")};
        transition: 1.3s;
        z-index: 5;
      }
      .icone02 {
        color: ${(props) => (props.darkmode ? "white" : "black")};
        transition: 1.3s;
        z-index: 5;
      }
      @media (max-width: 600px) {
        /* background-color: red; */
        width: 50px;
        span {
          /* position: relative; */
          left: 3px;
        }
        .icone01 {
          position: absolute;
          left: 10px;
          font-size: 25px;
          display: ${(props) => (props.darkmode ? "none" : "block")};
        }
        .icone02 {
          position: absolute;
          left: 10px;
          font-size: 25px;
          display: ${(props) => (props.darkmode ? "block" : "none")};
        }
      }
    }
    button {
      font-size: 40px;
      cursor: pointer;
      padding: 0;
      background-color: transparent;
      border: none;
      z-index: 3;
    }
    .iconStyledAlert {
      color: rgba(118, 118, 118, 1);
      transition: 0.5s;
    }
    .iconStyledAlert:hover {
      color: rgb(34, 34, 34);
    }
    .iconStyledAlertPorcesso {
      color: rgb(224, 169, 3);
      filter: drop-shadow(0px 0px 5px rgba(251, 255, 4, 0.45));

      animation: alertAnim 2s ease infinite;
    }
    .iconStyledAlertEmegencia {
      color: rgb(224, 3, 3);
      filter: drop-shadow(0px 0px 5px rgba(252, 0, 0, 0.45));
      animation: alertAnim 1s ease infinite;
    }
  }

  .elevatoriasUl {
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 85%;
    max-width: 100%;
    margin-top: 60px;
    list-style: none;
    @media (min-width: 1500px) {
      width: 80%;
    }
    .liElevatoria {
      width: 100%;
      max-width: 100%;
      height: 100%;
      margin-top: 95px;
      @media (min-width: 1600px) {
        margin-top: 95px;
      }

      .tituloPoco {
        margin: 1em 0 2em 0;
        display: flex;
        /* flex-direction: column; */
        align-items: center;
        justify-content: center;
        height: 50px;
        width: 30%;
        background: var(--cor-primaria);
        box-shadow: 2px 2px 10px var(--shadow);
        color: var(--branco);
        border-radius: 0 25px 25px 0;
        /* padding: 0 2% 0 9%; */
        /* padding-left: 25px; */
        gap: 5px;
        position: absolute;
        top: 60px;
        left: 0;
        .iconBack {
          font-size: 30px;
          cursor: pointer;
        }
        .tituloStatus {
          h3,
          h2 {
            font-size: 20px;
          }
          display: flex;
          gap: 15px;
          .statusPoco {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            gap: 5px;

            .statusDisplay {
              width: 20px;
              height: 20px;
              border-radius: 50%;
            }
            .StatusOFF {
              background-color: var(--offline);
              border: 1px solid var(--branco);
            }
            .StatusOn {
              background-color: var(--online);
              border: 1px solid var(--branco);
            }
            p {
              font-size: 20px;
            }
          }
        }
        @media screen and (max-width: 800px) {
          width: 70%;
          .tituloStatus {
            h3,
            h2 {
              font-size: 18px;
            }
          }
          .statusPoco {
            p {
              display: none;
            }
          }
        }
      }
    }

    section {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      width: 100%;
      height: 100%;
      min-height: 75vh;
      .blocoPocoTabela {
        display: flex;
        width: 100%;
        justify-content: space-around;
        flex-wrap: wrap;
        gap: 20px;
        .pocoStatusConteiner {
          display: flex;
          flex: 0 0 715px;
          min-width: 715px;
          gap: 10px;
          justify-content: center;
          flex-wrap: wrap;
          height: fit-content;
          max-width: 100%;

          @media (max-width: 730px) {
            min-width: 400px;
            max-width: 100%;
          }
          .pocoStatus {
            display: flex;
            gap: 5px;
            align-items: center;
            .blocoPoco {
              display: flex;
              align-items: end;
              width: 220px;
              position: relative;
              height: fit-content;
            }
            .infoAltura {
              display: flex;
              flex-direction: column;
              justify-content: center;
              gap: 15px;

              .divInfo {
                width: 130px;
                display: flex;
                align-items: center;
                gap: 5px;
                .info {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: var(--cor-contraste);
                  font-size: 13px;
                  width: 60px;
                  min-width: min-content;
                  height: 30px;
                  background-color: var(--branco);
                  border: 2px solid var(--cor-contraste);
                  border-radius: 3px;
                }
                p {
                  color: ${(props) =>
                    props.darkmode
                      ? "var(--fonte-dark-eee)"
                      : "var(--cor-contraste)"};
                  font-size: 14px;
                  width: 50%;
                  min-width: min-content;
                }
              }
              .ControlerInf {
                display: flex;
                flex-direction: column;
                gap: 5px;
                margin-top: 40px;
                p {
                  font-size: 19;
                  color: ${(props) =>
                    props.darkmode
                      ? "var(--fonte-dark-eee)"
                      : "var(--cor-contraste)"};
                  font-weight: 600;
                  /* margin-bottom: 5px; */
                }
                .infoButton {
                  font-size: 12px;

                  color: ${(props) =>
                    props.darkmode
                      ? "var(--fonte-dark-eee)"
                      : "var(--cor-contraste)"};
                  font-weight: 600;
                }
              }
            }
          }
          .BlocoInfoPoco {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            border: 2px solid var(--cor-primaria);
            box-shadow: 2px 2px 10px var(--shadow);
            border-radius: 10px;
            height: 435px;
            width: 350px;
            background-color: ${(props) =>
              props.darkmode && "var(--conteiner-dark-eee)"};

            @media (max-width: 730px) {
              width: 83%;
              height: 500px;
            }
            h3 {
              margin: 15px 0;
              display: flex;
              align-items: center;
              justify-content: center;
              color: var(--branco);
              background: var(--degrade);
              width: 100%;
              max-width: 100%;
              height: 30px;
              padding: 3px;
            }

            .dadosInfoPoco {
              padding: 10px;
              display: flex;
              align-items: center;
              justify-content: end;
              gap: 20px;
            }

            .dadosPoco {
              display: flex;
              flex-direction: column;
              align-items: end;
              max-width: 100%;
              text-align: right;
              color: ${(props) =>
                props.darkmode
                  ? "var(--fonte-dark-eee)"
                  : "var(--cor-contraste)"};

              .cxInfoPoco {
                width: 75px;
                max-width: 100%;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: var(--cor-contraste);
                font-size: 15px;
                background-color: var(--branco);
                border: 2px solid var(--cor-contraste);
                border-radius: 3px;
                font-weight: 600;
              }
            }
            .blocoControle {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;
              color: var(--cor-contraste);
              position: relative;

              .controle {
                display: flex;
                width: 100%;
                justify-content: center;
                align-items: center;
                gap: 12px;
                margin-top: 22px;
                padding: 18px;
                flex-wrap: wrap;
                .divControler {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  gap: 5px;
                }

                h3 {
                  position: absolute;
                  color: var(--branco);
                  top: -20px;
                  background: var(--degrade);
                  width: 100%;
                  text-align: center;
                  height: 30px;
                }
                p {
                  width: 80px;
                  font-weight: 600;
                  color: ${(props) =>
                    props.darkmode
                      ? "var(--fonte-dark-eee)"
                      : "var(--cor-contraste)"};
                }
                .cxControle {
                  padding: 15px;
                  width: 40px;
                  max-width: 100%;
                  height: 30px;
                  border-radius: 3px;
                  border: 2px solid var(--cor-contraste);
                  background-color: var(--branco);
                }
              }
            }
          }
        }
        .blocoTabelaGrafico {
          display: flex;
          flex: 1 1 0; /* cresce para ocupar todo o resto */
          min-width: 450px; /* só quebra quando não tiver 250px disponíveis */
          flex-direction: column;
          gap: 18px;
          @media (min-width: 1000px) {
            min-height: 410px;
          }
          @media (max-width: 660px) {
            min-width: 300px;
            max-width: 100%;
            height: 550px;
          }
          @media (max-width: 1390px) {
            max-width: 720px;
          }
          .blocoTabelaConteiner {
            display: flex;
            align-items: end;
            gap: 10px;

            @media (max-width: 660px) {
              flex-direction: column;
            }
            .blocoTabela {
              background-color: var(--branco);
              max-width: 100%;
              height: 120px;
              max-height: 100%;
              border: 3px solid var(--cor-primaria);
              box-shadow: 2px 2px 10px var(--shadow);
              border-radius: 10px;
              display: flex;
              align-items: start;
              justify-content: center;
              overflow-y: auto;
              @media (max-width: 660px) {
                height: 200px;
              }

              .tabela {
                background-color: var(--branco);
                width: fit-content;
                max-width: 100%;
                border-collapse: collapse;
                text-align: center;
                flex-direction: column;
                background-color: ${(props) =>
                  props.darkmode
                    ? "var(--conteiner-dark-eee)"
                    : "var(--branco)"};

                tbody {
                  tr {
                    width: 100%;
                  }
                  .mensagemTr {
                    white-space: nowrap; /* Impede que o texto quebre linha */
                    overflow: hidden; /* Oculta o conteúdo excedente */
                    text-overflow: ellipsis; /* Adiciona "..." no final */
                    max-width: 100px; /* Define um tamanho máximo para truncar o texto */
                  }
                }
                td {
                  width: 400px;
                  max-width: 100%;
                  border: 1px solid #aaaaaa;
                  padding: 3px 0;
                  font-size: 12px;
                  font-weight: bold;
                  color: var(--cor-contraste);
                  color: ${(props) =>
                    props.darkmode
                      ? "var(--fonte-dark-eee)"
                      : "var(--cor-contraste)"};
                }
                thead {
                  background: var(--degrade);
                  border: 1px solid red;
                }
                th {
                  padding: 3px 5px;
                  font-size: 15px;
                  color: var(--branco);
                }
              }
            }

            .blocoTabela::-webkit-scrollbar {
              width: 2px;
              height: 2px;
            }

            .blocoTabela::-webkit-scrollbar-thumb {
              background: var(--cor-primaria);
              border-radius: 10px;
            }
            .botaoTabela {
              display: flex;
              flex-direction: column;
              height: 100%;
              justify-content: space-around;
              align-items: center;
              /* gap: 5px; */
              @media (max-width: 660px) {
                flex-direction: row;
                width: 100%;
                height: 60px;
              }
              button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 180px;
                height: 40px;
                max-width: 100%;
                font-size: 20px;
                transition: 0.5s;
                background: transparent;
                border-radius: 3px;
                cursor: pointer;
                color: var(--cor-primaria);
                font-weight: bold;
                border: 2px solid var(--cor-primaria);
                @media (max-width: 660px) {
                  width: 140px;
                  font-size: 16px;
                }
              }
              button:hover {
                background: var(--degrade);
                color: var(--branco);
                border: 2px solid var(--cor-primaria);
                box-shadow: 2px 2px 10px var(--shadow);
              }
            }
          }
        }
      }
      .botaoBombas {
        display: flex;
        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 180px;
          height: 40px;
          max-width: 100%;
          gap: 5px;
          font-size: 20px;
          transition: 0.5s;
          margin: 16px 0;
          background-color: transparent;
          border-radius: 3px;
          cursor: pointer;
          color: var(--cor-primaria);
          font-weight: bold;
          border: 2px solid var(--cor-primaria);

          .icone {
            font-size: 30px;
          }
        }

        button:hover {
          background: var(--cor-primaria);
          color: var(--branco);
          border: 2px solid var(--cor-primaria);
          box-shadow: 2px 2px 10px var(--shadow);
        }
      }
      .ulBomba {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        list-style: none;
        .tituloBomba {
        }
        ul {
          list-style: none;
        }
      }

      .bombasSection {
        animation: myAnim 2s ease 0s 1 normal forwards;
      }
      .sectionAberta {
        overflow: visible;
        height: min-content;
        /* padding: 10px 60px; */
      }
    }
  }

  @media only screen and (min-width: 1600px) {
    /* background-color: aqua; */
    .elevatoriasUl {
      max-width: 1350px;
      /* background-color: red; */
    }
  }

  @media only screen and (max-width: 800px) and (orientation: portrait) {
    /* .IconAlerte {
      display: flex;
      justify-content: end;
      position: absolute;
      width: 100%;
      top: 10%;
      padding-right: 15%;
      background-color: aqua;
      button {
        font-size: 40px;
        cursor: pointer;
        padding: 0;
        background-color: transparent;
        border: none;
        z-index: 3;
      }
      .iconStyledAlert {
        color: rgba(118, 118, 118, 1);
        transition: 0.5s;
      }
      .iconStyledAlert:hover {
        color: rgb(34, 34, 34);
      }
      .iconStyledAlertPorcesso {
        color: rgb(224, 169, 3);
        filter: drop-shadow(0px 0px 5px rgba(251, 255, 4, 0.45));

        animation: alertAnim 2s ease infinite;
      }
      .iconStyledAlertEmegencia {
        color: rgb(224, 3, 3);
        filter: drop-shadow(0px 0px 5px rgba(252, 0, 0, 0.45));
        animation: alertAnim 1s ease infinite;
      }
    } */

    .elevatoriasUl {
      .liElevatoria {
        /* .tituloPoco {
          width: 65%;
          .tituloStatus {
            h3,
            h2 {
              font-size: 18px;
            }
          }
          .statusPoco {
            p {
              display: none;
            }
          }
        } */

        section {
          padding: 0;
          .blocoPocoTabela {
            justify-content: center;
            gap: 10px;
            .blocoPoco {
              width: 165px;
            }

            .infoAltura {
              .divInfo {
                .info {
                }
                p {
                }
              }
            }

            .BlocoInfoPoco {
              h3 {
              }

              .dadosInfoPoco {
              }

              .dadosPoco {
                .cxInfoPoco {
                }
              }
              .blocoControle {
                .controle {
                  h3 {
                  }
                  p {
                  }
                  .cxControle {
                  }
                }
              }
            }

            .tabelaGrafico {
              .blocoTabela {
                .tabela {
                  tbody {
                    tr {
                    }
                  }
                  td {
                  }
                  thead {
                  }
                  th {
                  }
                }
              }
              .botaoTabela {
                button {
                }
                button:hover {
                }
              }
            }
          }

          .botaoBombas {
            button {
              .icone {
              }
            }

            button:hover {
            }
          }
          .ulBomba {
            .tituloBomba {
            }
            ul {
            }
          }
        }

        .bombasSection {
        }
        .sectionAberta {
        }
      }
    }
  }

  @media only screen and (max-width: 940px) and (orientation: landscape) {
    .elevatoriasUl {
      .liElevatoria {
        .tituloPoco {
          h2 {
          }
        }

        section {
          .infoPoco {
            .blocoPocoTabela {
              .blocoPoco {
              }

              .infoAltura {
                .divInfo {
                  .info {
                  }
                  p {
                  }
                }
              }
              .BlocoInfoPoco {
                h3 {
                }

                .dadosInfoPoco {
                }

                .dadosPoco {
                  .cxInfoPoco {
                  }
                }
                .blocoControle {
                  .controle {
                    h3 {
                    }
                    p {
                    }
                    .cxControle {
                    }
                  }
                }
              }
              .tabelaGrafico {
                .blocoTabela {
                  .tabela {
                    tbody {
                      tr {
                      }
                    }
                    td {
                    }
                    thead {
                    }
                    th {
                    }
                  }
                }
                .botaoTabela {
                  button {
                    cursor: pointer;
                  }
                  button:hover {
                  }
                }
              }
            }
          }

          .botaoBombas {
            button {
              .icone {
              }
            }

            button:hover {
            }
          }
          .ulBomba {
            .tituloBomba {
            }
            ul {
            }
          }
        }

        .bombasSection {
        }
        .sectionAberta {
        }
      }
    }
  }
`;

export const EventosFalhasStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  box-shadow: 2px 2px 10px var(--shadow);
  z-index: 11;

  .container {
    margin: 10px;
    width: 700px;
    min-width: 65%;
    height: 70%;
    border-radius: 10px;
    padding: 20px;
    background: var(--cinza);
    border: 5px solid var(--cor-primaria);
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;

    .cabecalho {
      display: flex;
      justify-content: space-between;
      h3 {
        color: var(--cor-contraste);
        margin-bottom: 20px;
      }
      span {
        width: 20px;
        font-size: 20px;
        cursor: pointer;
      }
    }
    .tabelaGeral {
      height: 90%;
      overflow-x: hidden;

      .tabela {
        background-color: var(--branco);
        border: 3px solid var(--cor-primaria);
        border-radius: 10px;
        width: fit-content;
        max-width: 100%;
        border-collapse: collapse;
        text-align: center;
        flex-direction: column;

        tbody {
          tr {
            width: 100%;
          }
        }
        td {
          width: 400px;
          max-width: 100%;
          border: 1px solid #aaaaaa;
          padding: 3px;
          font-size: 12px;
          font-weight: bold;
          color: var(--cor-contraste);
        }
        thead {
          background: var(--cor-contraste);
        }
        th {
          padding: 3px 5px;
          font-size: 15px;
          color: var(--branco);
          font-weight: bold;
          border-left: 5px solid #d0e4f5;
        }
      }
    }

    .setasPaginacao {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin: 5px;
      .disable {
        opacity: 0.2;
        cursor: no-drop;
      }
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        font-size: 20px;
        transition: 0.5s;
        background: var(--branco);
        border-radius: 3px;
        cursor: pointer;
        color: var(--cor-primaria);
        font-weight: bold;
        border: 2px solid var(--cor-primaria);
      }
      button:hover {
        background-color: var(--cor-primaria);
        color: var(--branco);
        border: 2px solid var(--cor-primaria);
        box-shadow: 2px 2px 10px var(--shadow);
      }
    }

    .botaoEventos {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 140px;
      height: 30px;
      max-width: 100%;
      font-size: 20px;
      transition: 0.5s;
      background: var(--branco);
      border-radius: 3px;
      cursor: pointer;
      color: var(--cor-primaria);
      font-weight: bold;
      border: 2px solid var(--cor-primaria);
    }
    .botaoEventos:hover {
      background-color: var(--cor-primaria);
      color: var(--branco);
      border: 2px solid var(--cor-primaria);
      box-shadow: 2px 2px 10px var(--shadow);
    }
  }

  .modal-options {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 12;

    .modal-content {
      width: 400px;
      background: var(--cinza);
      border: 3px solid var(--cor-primaria);
      border-radius: 10px;
      padding: 20px;
      text-align: center;

      h4 {
        color: var(--cor-contraste);
        margin-bottom: 20px;
      }

      .form-group {
        margin-bottom: 15px;
        text-align: left;

        label {
          display: block;
          margin-bottom: 5px;
          color: var(--cor-contraste);
        }

        select,
        input[type="date"] {
          width: 100%;
          padding: 8px;
          border-radius: 5px;
          border: 1px solid #cccccc;
        }

        input[type="date"]::-webkit-calendar-picker-indicator {
          filter: brightness(0.7);
        }
      }

      .buttons {
        display: flex;
        justify-content: center;
        margin-top: 20px;
        gap: 20px;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 140px;
          height: 30px;
          max-width: 100%;
          font-size: 20px;
          transition: 0.5s;
          background: var(--branco);
          border-radius: 3px;
          cursor: pointer;
          color: var(--cor-primaria);
          font-weight: bold;
          border: 2px solid var(--cor-primaria);
        }
        button:hover {
          background-color: var(--cor-primaria);
          color: var(--branco);
          border: 2px solid var(--cor-primaria);
          box-shadow: 2px 2px 10px var(--shadow);
        }
      }
    }
  }
`;

export const BombasStyled = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-around;
  text-align: center;

  padding: 0;
  margin: 0;
  width: 105%;
  max-width: 103%;
  height: 100%;
  .tituloBombas {
    padding: 35px 0px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 476px;
    h2 {
      text-align: center;
      font-weight: 600;
      color: ${(props) =>
        props.darkmode ? "var(--fonte-dark-eee)" : "var(--cor-contraste)"};
    }

    img {
      width: 80%;
      max-width: 600px;
      margin: 10px 0;
    }
  }
  .statusBomba {
    display: flex;
    align-items: center;
    justify-content: space-around;
    text-align: center;
    width: 100%;
    li {
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 5px;
      color: ${(props) =>
        props.darkmode ? "var(--fonte-dark-eee)" : "var(--cor-contraste)"};
    }
  }
  .conteinerInforBombas {
    width: 500px;
    /* border: 2.5px solid var(--cor-primaria); */
    border: 2.5px solid
      ${(props) => (props.darkmode ? "#090E4F" : "var(--cor-primaria)")};
    box-shadow: 2px 2px 10px var(--shadow);
    border-radius: 15px;
    padding: 10px;
    margin: 20px 0;
    position: relative;

    background-color: ${(props) =>
      props.darkmode && "var(--conteiner-dark-eee)"};

    .RelatorioInfoBombas {
      position: absolute;
      right: 25px;
      font-size: 30px;
      cursor: pointer;
    }
    .blocoInfoBombas {
      color: var(--cor-contraste);
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${(props) =>
        props.darkmode ? "var(--fonte-dark-eee)" : "var(--cor-contraste)"};

      ul {
        width: 80%;
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 10px;
        li {
          display: flex;
          gap: 20px;
          width: 100%;
          align-items: center;
          .infoTexto {
            text-align: end;
            color: ${(props) =>
              props.darkmode
                ? "var(--fonte-dark-eee)"
                : "var(--cor-contraste)"};
          }
          p {
            width: 80px;
            font-weight: 600;
            color: var(--cor-contraste);
          }
        }
      }
      .cxInfoBombas {
        width: 100px;
        height: 30px;
        background-color: var(--branco);
        border: 2px solid var(--cor-contraste);
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
        color: var(--cor-contraste);
      }
    }
    .switchButton {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 15px;
      flex-direction: column;
      .buttonReveso {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;

        span {
          font-size: 15px;
          border-bottom: 2px solid rgba(97, 97, 97, 0.8);
        }
        .iconReverso {
          font-size: 25px;
          background-color: rgba(97, 97, 97, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 3px;
          padding: 2px;
          border-radius: 50%;
          cursor: pointer;
          color: rgba(42, 42, 42, 0.79);
          /* border: 2px solid black; */
        }
        .iconReversoOn {
          background-color: rgba(48, 208, 8, 0.93);
        }
        display: flex;
      }
    }
  }

  @media (max-width: 1222px) {
    flex-direction: column;
    gap: 20px;
  }
  @media (max-width: 696px) {
    .conteinerInforBombas {
      max-width: 100%;
      padding: 15px;

      .blocoInfoBombas {
        display: flex;
        align-items: center;
        justify-content: center;

        ul {
          width: 80%;
          display: flex;
          flex-direction: column;
          gap: 5px;
          padding: 10px;
          li {
            display: flex;
            gap: 20px;
            width: 100%;
            align-items: center;
          }
        }
      }
    }
  }
  @media (max-width: 590px) {
    .conteinerInforBombas {
      padding: 0 15px 15px 15px;
      .blocoInfoBombas {
        ul {
          li {
            p {
            }
          }
        }
        .cxInfoBombas {
        }
      }
    }
  }
  @media (max-width: 550px) {
    .statusBomba {
      font-size: 10px;
    }
    .conteinerInforBombas {
      .blocoInfoBombas {
        ul {
          li {
            gap: 10px;
            p {
              font-size: 12px;
              width: 30px;
            }
          }
        }
        .cxInfoBombas {
          font-size: 16px;
          width: 90px;
          margin-left: 30px;
          height: 30px;
          border: 2px solid var(--cor-contraste);
        }
      }
    }

    .blocoInfoBombas {
      width: 360px;
      max-width: 100%;
      gap: 0px;

      ul {
        width: 80%;
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 10px;
        li {
          display: flex;
          gap: 20px;
          width: 100%;
          align-items: center;
          .infoTexto {
            text-align: end;
          }
          p {
            width: 80px;
            font-weight: 600;
            color: black;
          }
        }
      }
      .cxInfoBombas {
        width: 100px;
        height: 30px;
        background-color: var(--branco);
        border: 2px solid var(--cor-contraste);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
      }
    }

    .switchButton {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
  @media (max-width: 470px) {
    .statusBomba {
      font-size: 10px;
    }
    .conteinerInforBombas {
      width: 450px;
      .blocoInfoBombas {
        ul {
          li {
            gap: 10px;
            p {
              font-size: 12px;
              width: 30px;
            }
          }
        }
        .cxInfoBombas {
          font-size: 12px;
          width: 70px;
          margin-left: 30px;
          color: black;
          height: 30px;
          font-weight: 600;
          border: 2px solid var(--cor-contraste);
        }
      }
    }

    .blocoInfoBombas {
      width: 360px;
      max-width: 100%;
      gap: 0px;

      ul {
        width: 80%;
        display: flex;
        flex-direction: column;
        gap: 5px;
        padding: 10px;
        li {
          display: flex;
          gap: 20px;
          width: 100%;
          align-items: center;
          .infoTexto {
            text-align: end;
          }
          p {
            width: 80px;
            font-weight: 600;
            color: black;
          }
        }
      }
      .cxInfoBombas {
        width: 100px;
        height: 30px;
        background-color: var(--branco);
        border: 2px solid var(--cor-contraste);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
      }
    }
    .switchButton {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
`;

export const StatusBomba = styled.div`
  width: 50px;
  height: 50px;
  border: 2px solid var(--cor-primaria);
  border-radius: 10px;
  box-shadow: 2px 2px 10px var(--shadow);
  background: ${(props) => props.status};

  @media (max-width: 590px) {
    width: 40px;
    height: 40px;
  }
`;

export const BotaoOnOff = styled.button`
  width: 120px;
  height: 50px;
  border-radius: 25px;
  border: none;
  position: relative;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? "0.7" : "1")};

  ${({ valor }) =>
    valor
      ? css`
          background-color: green;
        `
      : css`
          background-color: var(--cor-infor);
        `}

  .status {
    position: absolute;
    top: 15px;
    left: 15px;
    font-size: 17px;
    color: var(--branco);
    ${({ valor }) =>
      valor
        ? css`
            left: 25px;
          `
        : css`
            left: 58px;
          `}
  }
  :hover {
    ${({ disabled }) =>
      disabled &&
      css`
        &::after {
          content: "Não autorizado";
          background-color: var(--cor-contraste);
          padding: 10px;
          width: 100px;
          border-radius: 10px;
          color: white;
          font-weight: bold;
          position: absolute;
          top: calc(100% + 15px);
          left: 0;
          font-size: 10px;
        }
      `}
  }
`;

export const rotateAnimation = keyframes`
from {
  transform: rotate(360deg);
}
to {
  transform: rotate(0deg);
}
`;

export const Switch = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 46px;
  height: 46px;
  background-color: var(--branco);
  position: absolute;
  border-radius: 50%;
  transition: 1s;
  top: 2px;
  .carregar {
    width: 22px;
    height: 22px;
    color: var(--cor-contraste);
    animation: ${rotateAnimation} 1s linear infinite;
  }
  ${({ valor }) =>
    valor
      ? css`
          left: 71px;
        `
      : css`
          left: 3px;
        `}
`;

export const CxControle = styled.div`
  padding: 15px;
  width: 40px;
  max-width: 100%;
  height: 30px;
  border-radius: 5px;
  border: 2px solid rgb(15, 113, 137);
  background: ${(props) => props.activo};
`;

export const ModalStyledAvisoEmergencia = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 11;

  .conteiner {
    width: 80%;
    height: 85%;
    border-radius: 15px;
    background-color: aliceblue;
    position: relative;
    background: var(--cinza);
    border: 3px solid var(--cor-primaria);
    .Closemodal {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      width: 30px;
      height: 30px;
      right: -10px;
      top: -10px;
      font-size: 22px;
      cursor: pointer;
      background-color: var(--branco);
      border: 2px solid var(--cor-primaria);
      border-radius: 50%;
    }
    .SelectSections {
      display: flex;
      justify-content: center;
      width: 100%;
      gap: 15px;
      margin-top: 25px;
      h2 {
        cursor: pointer;
        padding: 2px;
        color: rgba(107, 107, 107, 0.8);
        border-bottom: 3px solid rgba(107, 107, 107, 0.8);
      }
      .sectionAtive {
        color: rgb(0, 0, 0);
        border-bottom: 3px solid rgb(0, 0, 0);
      }
    }
    section {
      display: flex;
      width: 100%;
      height: 100%;
      max-height: 90%;
      .alertsOk {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
      }
    }

    .ulHistorico {
      display: flex;
      flex-direction: column;
      gap: 25px;
      width: 100%;
      overflow: auto;
      padding: 15px;
      padding-top: 25px;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 2px;
        border-bottom: 4px solid rgba(6, 129, 25, 1);
        padding-right: 10px;
        .iconStyled {
          display: flex;
          margin-bottom: 5px;
          font-size: 40px;
          height: 100%;
          align-items: end;
        }
        .Status {
          display: flex;
          flex-direction: column;
          gap: 5px;
          align-items: center;
          justify-content: space-around;
          height: 100%;
          .top {
            font-weight: 600;
            font-size: 17px;
          }
          p {
            text-align: center;
            width: 350px;
            max-width: 100%;
            word-wrap: break-word; /* Quebra a palavra se for muito longa */
            overflow-wrap: break-word; /* Garante a quebra */
            white-space: normal; /* Permite múltiplas linhas */
          }
          .Statusalert {
            text-align: center;
            width: 150px;
            max-width: 100%;
            word-wrap: break-word; /* Quebra a palavra se for muito longa */
            overflow-wrap: break-word; /* Garante a quebra */
            white-space: normal; /* Permite múltiplas linhas */
          }
          button {
            padding: 5px;
            width: 100px;
            cursor: pointer;
            border: 2px solid;
            font-weight: 600;
            border-radius: 5px;
          }
          .buttonPendente {
            border: 2px solid rgb(201, 19, 6);
            color: rgb(201, 19, 6);
            transition: 0.5s;
          }
          .buttonPendente:hover {
            border: 2px solid rgb(217, 207, 12);
            color: white;
            background-color: rgb(217, 207, 12);
          }
          .buttonProgresso {
            border: 2px solid rgb(170, 145, 7);
            color: rgb(170, 145, 7);
            transition: 0.5s;
          }
          .buttonProgresso:hover {
            border: 2px solid rgba(6, 129, 25, 1);
            color: white;
            background-color: rgba(6, 129, 25, 1);
          }
        }
      }
      .pedente {
        border-bottom: 4px solid rgb(201, 19, 6);
      }
      .manuteçao {
        border-bottom: 4px solid rgb(201, 191, 6);
      }
    }
  }

  @media screen and (max-width: 1400px) {
    .conteiner {
      width: 95%;
      padding: 4px;
      h2 {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 2px;
        text-align: center;
        font-size: 20px;
      }
      .ulHistorico {
        height: 99%;
        li {
          gap: 8px;
          flex-direction: column;
          align-items: flex-start;

          .Status {
            display: flex;
            flex-direction: row;
            gap: 15px;
            .top {
              display: flex;
              align-items: center;
              height: 100%;
              /* justify-content: center; */
              max-width: 85px;
              min-width: 85px;

              /* background-color: red; */
            }
            p {
              text-align: start;
              width: 100%;
            }
          }
        }
      }
    }
  }
`;
